'use client';

import { useEffect, useState } from 'react';
import { CommandPalette } from './command-palette';

/**
 * Defer cmdk mount until after first client commit — same insertion-effect
 * guard as AppToaster / HelpChatWidget (Phase 1 SAH go-live runtime fix).
 */
export function DeferredCommandPalette() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return <CommandPalette />;
}
